/* EUNA affiliate referral capture.
   First-touch attribution: the first ref a visitor arrives with wins for 30 days.
   Written to the cart as attribute `ref` so orders stay attributed even when the
   multi-buy automatic discount rejects the affiliate's code. */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.EunaRef = api;
})(typeof self !== 'undefined' ? self : this, function () {
  var KEY = 'euna_ref';
  var TTL_MS = 30 * 86400000;
  var VALID = /^[a-z0-9][a-z0-9_-]{0,63}$/;

  function clean(value) {
    if (typeof value !== 'string') return null;
    var v = value.trim().toLowerCase();
    return VALID.test(v) ? v : null;
  }

  function resolveRef(search, stored, nowMs) {
    var live = null;
    if (stored && typeof stored === 'object' &&
        typeof stored.expires === 'number' && stored.expires > nowMs) {
      live = clean(stored.ref);
    }
    if (live) return { ref: live, expires: stored.expires };

    var incoming = null;
    try {
      incoming = clean(new URLSearchParams(search || '').get('ref'));
    } catch (e) {
      incoming = null;
    }
    if (!incoming) return null;
    return { ref: incoming, expires: nowMs + TTL_MS };
  }

  function read() {
    try {
      return JSON.parse(window.localStorage.getItem(KEY));
    } catch (e) {
      return null;
    }
  }

  function write(record) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(record));
    } catch (e) {
      /* private browsing, storage full: attribution degrades, checkout must not */
    }
  }

  function sync() {
    if (typeof window === 'undefined') return null;
    var record = resolveRef(window.location.search, read(), Date.now());
    if (record) write(record);
    return record ? record.ref : null;
  }

  function get() {
    if (typeof window === 'undefined') return null;
    var record = resolveRef('', read(), Date.now());
    return record ? record.ref : null;
  }

  if (typeof window !== 'undefined') {
    sync();
  }

  return { resolveRef: resolveRef, get: get, sync: sync };
});
